import { Select } from "antd";

function ActionDropdown({ value, onChange }: { value: string; onChange: (e: string) => void }) {
  return (
    <Select
      showSearch
      value={value}
      filterOption={(input, option: any) => option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0}
      onChange={onChange}
      className="w-40"
      placeholder="Select Request Type"
      allowClear
      options={[
        { value: "create", label: "CREATE" },
        { value: "update", label: "UPDATE" },
        { value: "delete", label: "DELETE" },
      ]}
    />
  );
}

export default ActionDropdown;
